module.exports = __webpack_public_path__ + "img/vp_web.b7671d09.png";